import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './layout/header';
import Footer from './layout/footer';
import Slider from './pages/landing/home/partials/slider';
import Landing from './pages/landing';
import User from './pages/user';
import { ToastContainer } from 'react-toastify';
import Admin from './pages/admin';
import ServerError from './pages/errors/server-error';
import NotFound from './pages/errors/not-found';
import { useFetchPropertiesQuery } from '../services';
import { useAppDispatch } from '../hooks';
import { setFeaturedProperties, setRecentProperties } from '../slices/property.slice';

const App = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const {
    data: recentProperties,
    isSuccess: fetchedRecentProperties,
  } = useFetchPropertiesQuery({
    sort: 'createdAt,DESC',
    limit: 2,
  });

  const {
    data: featuredProperties,
    isSuccess: fetchedFeaturedProperties,
  } = useFetchPropertiesQuery({
    sort: 'createdAt,DESC',
    limit: 3,
    featured: 1,
  });

  useEffect(() => {
    if (recentProperties) {
      dispatch(setRecentProperties(recentProperties));
    }
  }, [fetchedRecentProperties]);

  useEffect(() => {
    if (featuredProperties) {
      dispatch(setFeaturedProperties(featuredProperties));
    }
  }, [fetchedFeaturedProperties]);

  useEffect(() => {
    if (pathname === '/') {
      document.body.classList.remove("page-sub-page");
      "page-homepage navigation-fixed-top page-slider page-slider-search-box"
        .split(" ")
        .forEach(name => {
          document.body.classList.add(name);
        });
    } else {
      "page-homepage navigation-fixed-top page-slider page-slider-search-box"
        .split(" ")
        .forEach(name => {
          document.body.classList.remove(name);
        });
      document.body.classList.add("page-sub-page");
    }
  }, [pathname]);

  return (
    <ServerError>
      <div className="wrapper">
        <ToastContainer autoClose={5000}/>
        <Header/>
        {pathname === '/' && <Slider />}
        <Routes>
          <Route path={'/not/found'} element={<NotFound/>}/>
          <Route path={'/user/*'} element={<User/>}/>
          <Route path={'/admin/*'} element={<Admin/>}/>
          <Route path={'/*'} element={<Landing/>}/>
        </Routes>
        <Footer/>
      </div>
    </ServerError>
  );
}

export default App;
